module.exports = __webpack_public_path__ + "img/slika-3.00f8caeb.png";